const DATE_FIELDS = new Set(['due_date']);
const SELECT_FIELDS = new Set(['author_id', 'assignee_id', 'responsible_user_id']);

const normalizeSelectValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value ?? null;
};

const normalizeField = (key, value) => {
  if (SELECT_FIELDS.has(key)) return normalizeSelectValue(value);
  if (DATE_FIELDS.has(key)) return value?.format('YYYY-MM-DD') ?? null;

  return value ?? null;
};

const buildFormParams = ({ form }) => {
  const rawValues = form.getFieldsValue();

  return {
    ticket: Object.fromEntries(
      Object.entries(rawValues).map(([key, value]) => [
        key,
        normalizeField(key, value),
      ]),
    ),
  };
};

export default buildFormParams;
